import React from "react";
import playstation from "../../../assets/images/portfolio/project-playstation-main.png";

export default function ProfessionalProjects() {
    return (
        <section id="proProjectsSilentHill" className="proProjects__container silentHill__container anchor">
            <div className="container">
                <div className="box row projects__row silentHill__row">
                    <div className="proProjects__project-container col-lg-7 col-md-12 col-sm-12 col-12">
                        <div className="silentHill__imageBlocks">
                            <img
                                src={playstation}
                                className="proProjects__image proProjects__primary-image"
                                alt="Silent Hill: Ascension"
                            />
                        </div>
                        <div className="silentHill__yellowFlourish"></div>
                    </div>
                    <div className="proProjects__textBox col-lg-5 col-md-12 col-sm-12 col-12">
                        <div className="proProjects__overlay"></div>
                        <p className="proProjects__projectTitle">Sony PlayStation Mobile</p>
                        <p className="proProjects__description">I joined to mentor and lead technical teams across core platform and application layers, supporting the development of a large-scale, real-time mobile product for PlayStation.</p>
                        <p className="proProjects__description">As a founding member of PlayStation's mobile division, I helped establish engineering standards, performance targets, and delivery practices aligned with PlayStation quality expectations and global reach.</p>
                        <p className="proProjects__description">I led and scaled teams of managers, senior engineers, and external partners, overseeing architecture, budgeting, and execution across networking, backend services, build pipelines, and performance optimization.</p>
                        {/* <p className="proProjects__description">My work included migrating live services between vendors, designing high-availability cloud infrastructure on AWS, and establishing measurable KPIs to improve reliability, throughput, and development velocity across multiple platforms.</p> */}
                        <div className="primary-button__container">
                            <div className="proProject__capsule capsule">Engineering Mgmt</div>
                            <div className="proProject__capsule capsule">Head of Tech</div>
                            <div className="proProject__capsule capsule">Strategy</div>
                            <div className="proProject__capsule capsule">Vendor Mgmt</div>
                        </div>
                        <div className="primary-button__container">
                            <hr className="primary-button__line" />
                            <a
                                href="/projects"
                                rel="noreferrer"
                            >
                                <button className="primary-button">More Projects</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
